import { Button, Container, Typography } from "@mui/material";
import lineup from "../../images/assets/lineup_2026.png";
import leftImg from "../../images/assets/leftImg.png";
import rightImg from "../../images/assets/rightImg.png";
import videoWebm from "../../videos/bpf.webm";
import videoMp4 from "../../videos/bpf.mp4";

function Home() {
  return (
    <div className="home">
      <Container maxWidth="xl">
        <div className="modal-content">
          <div className="lineup-container lineup-container-desktop">
            <img src={lineup} className="lineup-image" alt="lineup" />
            {/* <div className="sponsor-image" >

              <Typography className="text sponsor-text">
                Official Festival Partner
              </Typography>

              <img src={sponsor} alt="sponsor" />
              </div > */}
          </div>

          <div className="video-container">
            <div>
              <img src={leftImg} className="lineup-image" alt="lineup" />
            </div>
            <div>
              <video width="100%" autoPlay loop muted playsInline>
                <source src={videoWebm} type="video/webm" />

                <source src={videoMp4} type="video/mp4" />
              </video>
            </div>
            <div>
              <img src={rightImg} className="lineup-image" alt="lineup" />
            </div>
          </div>

          <Typography className="title" variant="h6">
            Tickets On Sale Now
          </Typography>
          <Typography className="text">Friday 4th September 2026</Typography>

          <Button
            href="https://www.seetickets.com/event/brighton-psych-fest-2026/various-brighton-venues/3476833"
            color="primary"
            size="large"
            variant="contained"
            className="ticket-header-button"
            sx={{
              fontSize: "26px",
              margin: "0",
              padding: "8px 70px",
              textAlign: "center",
            }}
            target="_blank"
          >
            BUY TICKETS
          </Button>
        </div>
      </Container>
    </div>
  );
}
export default Home;
